module.exports = __webpack_public_path__ + "img/eTailing Summit-orig.e9e45010.png";